import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FieldGroupState } from '../../../models';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-filter-fields-group',
  templateUrl: './filter-fields-group.component.html',
  styleUrls: ['./filter-fields-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('parent', [transition(':enter', [])]),
    // To prevent initial animation
    // https://stackoverflow.com/questions/44111239/angular-is-there-a-way-to-skip-enter-animation-oninitial-render
    trigger('expandField', [
      transition(':enter', [
        style({ height: '0' }), // initial
        animate('0.2s', style({ height: '*' })), // final
      ]),
      transition(':leave', [
        style({ height: '*' }), // initial
        animate('0.2s', style({ height: '0' })), // final
      ]),
    ]),
  ],
  standalone: false,
})
export class FilterFieldsGroupComponent {
  @Input()
  fieldsGroup: FieldGroupState;

  @Input()
  filterInstanceId: string;
}
